import { useMemo } from 'react';
import { useGetPortalNavigationQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/NavigationRpc.hooks';
import { getPortalAccountId, getPortalInstanceId, getIsPortalDeployed } from '../utils/metadata';
function toSideNavItem(item, hrefBase, isCurrent) {
  var _item$badge, _item$children;
  return {
    id: item.id,
    href: item.path ? `${hrefBase}${item.path}` : undefined,
    path: item.path,
    isCurrent,
    external: item.external,
    badgeCount: (_item$badge = item.badge) === null || _item$badge === void 0 ? void 0 : _item$badge.count,
    children: ((_item$children = item.children) !== null && _item$children !== void 0 ? _item$children : []).slice().sort((a, b) => {
      var _a$order, _b$order;
      return ((_a$order = a.order) !== null && _a$order !== void 0 ? _a$order : 0) - ((_b$order = b.order) !== null && _b$order !== void 0 ? _b$order : 0);
    }).map(child => toSideNavItem(child, hrefBase, isCurrent))
  };
}
export function usePortalNavigation() {
  var _data$siteMenuData;
  const {
    data
  } = useGetPortalNavigationQuery({
    variables: {
      accountId: getPortalAccountId(),
      portalInstanceId: getPortalInstanceId()
    }
  });
  const navItems = useMemo(() => {
    var _data$portalNavigatio;
    const isLocal = !getIsPortalDeployed();
    const entries = (_data$portalNavigatio = data === null || data === void 0 ? void 0 : data.portalNavigationEntries) !== null && _data$portalNavigatio !== void 0 ? _data$portalNavigatio : [];
    return entries.flatMap(entry => {
      var _entry$navigationMani;
      if (!((_entry$navigationMani = entry.navigationManifest) !== null && _entry$navigationMani !== void 0 && _entry$navigationMani.items)) return [];
      const hrefBase = isLocal ? new URL(`https://${entry.baseUrl}`).pathname.replace(/\/$/, '') : entry.baseUrl;
      return entry.navigationManifest.items.slice().sort((a, b) => {
        var _a$order2, _b$order2;
        return ((_a$order2 = a.order) !== null && _a$order2 !== void 0 ? _a$order2 : 0) - ((_b$order2 = b.order) !== null && _b$order2 !== void 0 ? _b$order2 : 0);
      }).map(item => toSideNavItem(item, hrefBase, entry.isCurrent));
    });
  }, [data]);
  return {
    navItems,
    siteMenuData: (_data$siteMenuData = data === null || data === void 0 ? void 0 : data.siteMenuData) !== null && _data$siteMenuData !== void 0 ? _data$siteMenuData : undefined
  };
}